import {Hydra} from '../generic/hydra';

import {UtilisateurRoleInterface} from './UtilisateurRole';
import {CountryInterface} from './Country';
import {FichierInterface} from './Fichier';
import {AffiliationInterface} from './Affiliation';
import {UtilisateurTypeInterface} from './UtilisateurType';
import {StatutChercheurInterface} from './StatutChercheur';
import {AdresseInterface} from './Adresse';
import {MotCleInterface} from './MotCle';
import {UtilisateurDisciplineInterface} from './UtilisateurDiscipline';
import {LaboratoireInterface} from './Laboratoire';
import {MandatInterface} from './Mandat';
import {UtilisateurSignatureInterface} from './UtilisateurSignature';
import {UtilisateurDeclarationInteretInterface} from './UtilisateurDeclarationInteret';
import {LocalisationInfoInterface} from './LocalisationInfo';
import {Utilisateur as UtilisateurBaseInterface} from '../../interface/api/Utilisateur';
import {Cofinanceur} from "../../interface/api/Cofinanceur";

export type UtilisateurInterface = UtilisateurBaseInterface;

export class Utilisateur extends Hydra implements UtilisateurInterface {

    id?: number | null;

    username?: string | null;

    email?: string | null;

    nom?: string | null;

    nomNaissance?: string | null;

    prenom?: string | null;

    locale?: string | null;

    localeBrowser?: string | null;

    password1?: string | null;

    password2?: string | null;

    enabled?: boolean | null;

    deleted?: boolean | null;

    utilisateurRoles?: UtilisateurRoleInterface[] | null = [];

    nationalites?: CountryInterface[] | string[] | null = [];

    dateNaissance?: Date | null;

    numORCID?: string | null;

    phd?: boolean | null;

    phdDate?: Date | null;

    titre?: string | null;

    civilite?: string | null;

    cvCourt?: string | null;

    /* Objet Fichier, avec un FichierType 'cv_chercheur'
     */
    cvFichier?: FichierInterface | string | null;

    telPerso?: string | null;

    /* Objet Fichier, avec un FichierType 'profilePicture'
     */
    photo?: FichierInterface | string | null;

    infosExpertObligatoires?: boolean | null = false;

    affiliation?: AffiliationInterface | string | null;

    affiliationOther?: string | null;

    utilisateurType?: UtilisateurTypeInterface | string | null;

    utilisateurTypeOther?: string | null;

    statutChercheur?: StatutChercheurInterface | string | null;

    statutChercheurOther?: string | null;

    adresse?: AdresseInterface | string | null;

    dateInscription?: string | Date | null;

    dateDerniereModification?: string | Date | null;

    dateDerniereConnexion?: string | Date | null;

    motCles?: string[] | MotCleInterface[] | null = [];

    utilisateurDisciplines?: string[] | UtilisateurDisciplineInterface[] | null = [];

    emailPro?: string | null;

    telPro?: string | null;

    /* Fournit la plupart du temps sous forme d'IRI
     */
    laboratoire?: string | LaboratoireInterface | null;

    mandats?: string[] | MandatInterface[] | null = [];

    utilisateurSignatures?: string[] | UtilisateurSignatureInterface[] | null = [];

    declarationInteret?: UtilisateurDeclarationInteretInterface | null;

    infosLocalisation?: LocalisationInfoInterface | null;

    mandatsActifsCE?: string[] | MandatInterface[] | null = [];

    /* Nombre de nominations total [Readonly]
     */
    dossierExpertsTotalCount?: number | null = 0;

    dossierExpertsTotalParStatutCount?: { 'statut0'?: number;'statut1'?: number;'statut2'?: number;'statut3'?: number;'statut5'?: number } | null;

    /* Nombre de dossiers à traiter, toutes commissions confondues [Readonly]
     */
    dossierExpertsATraiterCount?: number | null = 0;

    dossierExpertsATraiterParStatutCount?: { 'statut0'?: number;'statut1'?: number;'statut2'?: number;'statut3'?: number;'statut5'?: number } | null;

    passwordLocked?: boolean | null = false;

    memberOfCoFinanceur?: null | string | Cofinanceur;


    constructor(options: UtilisateurInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
